<template lang="pug">
form.__form-extended(@submit.prevent='submit', :action='action')
  template(v-for='field in list')
    input(
      v-if='field.type === "hidden"',
      :type='field.type',
      :name='field.code',
      :value='values[field.code]'
    )
    .element(v-else)
      component.control(
        :auto-width='true',
        :is='`element-${field.type}`',
        :large='false',
        :filterable='field.filterable',
        :placeholder='field.placeholder || field.title',
        :multiple='field.multiple',
        :name='field.code',
        :options='field.options ? field.options : undefined',
        :value='values[field.code]',
        @input='change(field.code, $event)'
      )
  .element
    button-default(
      :styleParams='styleParams',
      :wide='true',
      :factor='1.35',
      color='filter',
      @click='submit'
    ) {{ buttonText }}
</template>

<script>
import ButtonDefault from '@/components/ext/Button.vue';
import {
  Input as ElementInput,
  Select as ElementSelect,
  Calendar as ElementCalendar,
} from '@/components/form';

export default {
  components: {
    ButtonDefault,
    ElementCalendar,
    ElementInput,
    ElementSelect,
  },
  props: {
    container: String,
    action: String,
    fields: Array,
    buttonText: String,
    styleParams: Object,
  },
  created() {
    this.fields.forEach((item) => {
      if (!item.multiple) {
        this.$set(this.values, item.code, item.value);
      } else {
        let value = item.value;
        if (Array.isArray(value)) {
          value = value.map((value) => {
            let ret = { value };
            ret.text = item.data.find(({ name, id }) => {
              return id === value;
            }).name;
            return ret;
          });
        }
        this.$set(this.values, item.code, value);
      }
    });
  },
  data() {
    return {
      values: {},
    };
  },
  computed: {
    list() {
      return this.fields.map((item) => {
        let result = {
          title: item.title || '',
          placeholder: item.placeholder || '',
          code: item.code,
          filterable: item.filterable || '',
          multiple: !!item.multiple,
          type: item.type || (item.data ? 'select' : 'input'),
        };
        if (item.data && Array.isArray(item.data)) {
          result.options = item.data.map((option) => ({
            text: (option && option.name) || '',
            value: (option && option.id) || '',
            selected: (item && item.value) === true,
          }));
        }
        return result;
      });
    },
  },
  methods: {
    change(code, value) {
      if (Array.isArray(value)) {
        this.values[code] = value.map((val) => {
          const spr = this.fields.find((_spr) => {
            return _spr.code === code;
          }).data;
          return {
            value: val,
            text: spr.find(({ name, id }) => {
              return id === val;
            }).name,
          };
        });
      } else {
        this.values[code] = value;
      }
      this.$emit('change', {
        code: code,
        value: value,
      });
    },

    submit() {
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scoped>
.__form-extended {
  .element {
    margin-bottom: 10px;
    text-align: center;
    display: block;

    .control {
      width: 100%;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Filter.vue?90968e42